import { apiInstances } from '../../../../libs';

const { post } = apiInstances.authInstance;

export default function makeLogin({ username, password }) {
  return post('/login/clouder', null, {
    auth: {
      username,
      password,
    },
    _ignoreReload: true,
  });
}
